import { CompletedPayment, PaymentMethod } from './models';

export interface CardPaymentMethod {
  method: PaymentMethodType.creditCard;
  paymentMethod: PaymentMethod;
  cardType: CreditCardType;
}

export type PaymentMethodPayload = { isSPOS?: boolean } & (CashPaymentMethod | CardPaymentMethod);
export type PaymentMethodPayloadData = Omit<CashPaymentMethod, 'paymentMethod'> | Omit<CardPaymentMethod, 'paymentMethod'>;

export interface CompletedPaymentResult {
  paymentMethod: PaymentMethod;
  completedPayment: CompletedPayment;
  type: PaymentMethodType;
  receivedAmount: number;
  isSPOS?: boolean;
}


export enum PaymentMethodType {
  cash = 'cash',
  creditCard = 'creditCard'
}

export interface CashPaymentMethod {
  method: PaymentMethodType.cash;
  paymentMethod: PaymentMethod;
  receivedAmount: number;
}

export type CreditCardType = 'cc' | 'ec'; // FIXME: where these values came from???

interface PaymentSubmitPayloadBase {
  user_id: number;
  payment_type: string;
  is_reservation?: boolean;
  reservation_id: number | null;
}

interface CardPaymentSubmitPayload extends PaymentSubmitPayloadBase {
  card_type: string;
}

interface CashPaymentSubmitPayload extends PaymentSubmitPayloadBase {
  received: number;
}

export type PaymentSubmitPayload = CardPaymentSubmitPayload | CashPaymentSubmitPayload;
